<template>
	<div class="hello">
		<canvas id="animatedLogoCanvas" width="240" height="240"></canvas>
	</div>
</template>

<script>
	import tweenlib from 'tween.js';

    var inputPrimaryColor = '#2196f3';
    var inputSecondaryColor = '#ffffff';

    var StyleKitName = {};
    (function() {

    //// Drawing Methods

    function drawLogo(canvas, process, targetFrame, resizing) {
        //// General Declarations
        canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
        if(!canvas){
            return
        }
        var context = canvas.getContext('2d');
        
        //// Resize to Target Frame
        context.save();
        var resizedFrame = applyResizingBehavior(resizing, makeRect(0, 0, 240, 240), targetFrame);
        context.translate(resizedFrame.x, resizedFrame.y);
        context.scale(resizedFrame.w / 240, resizedFrame.h / 240);
        context.rotate(Math.PI/8);


        //// Color Declarations
        var fillColor = inputPrimaryColor;
        var color = inputPrimaryColor;
        var fillColor2 = inputSecondaryColor;

        //// Variable Declarations
        var easing = process * 2;
        var position = easing * 50 + 55;
        var alpha = Math.sin(90 * easing * Math.PI/180);
        var rotation = -30 + easing * 30;

        //// Group


        //// Rectangle Drawing
        roundedRect(context, -37.73, -42.27, 100, 100, 18);
        context.fillStyle = color;
        context.fill();


        //// Group 2

        function group2CanvasLayer(width, height) {
            context.save();
            context.translate((position - 107.727507588), (position - 112.27));
            context.rotate(-rotation * Math.PI / 180);



            //// Bezier 2 Drawing
            context.beginPath();
            context.moveTo(10.99, 45.78);
            context.bezierCurveTo(7.75, 45.78, 4.56, 44.54, 2.46, 42.46);
            context.lineTo(-44.28, -3.8);
            context.bezierCurveTo(-47.34, -6.84, -48.54, -10.6, -47.53, -13.52);
            context.bezierCurveTo(-47.68, -13.75, -47.89, -14.03, -48.17, -14.31);
            context.lineTo(-52.05, -18.15);
            context.bezierCurveTo(-55.75, -21.81, -55.75, -27.76, -52.05, -31.41);
            context.lineTo(-40.3, -43.04);
            context.bezierCurveTo(-38.52, -44.81, -36.14, -45.78, -33.61, -45.78);
            context.bezierCurveTo(-31.07, -45.78, -28.69, -44.81, -26.91, -43.04);
            context.lineTo(-26.08, -42.23);
            context.bezierCurveTo(-25.98, -42.12, -25.88, -42.03, -25.78, -41.94);
            context.bezierCurveTo(-25.33, -42.05, -24.86, -42.11, -24.37, -42.11);
            context.bezierCurveTo(-21.38, -42.11, -18.71, -39.92, -17.39, -38.61);
            context.lineTo(17.52, -4.05);
            context.bezierCurveTo(17.74, -3.83, 18.44, -3.51, 19.25, -3.51);
            context.bezierCurveTo(19.67, -3.51, 19.88, -3.59, 19.92, -3.61);
            context.lineTo(32.72, -9.31);
            context.bezierCurveTo(33.94, -9.85, 35.22, -10.13, 36.54, -10.13);
            context.bezierCurveTo(40.35, -10.13, 43.72, -7.84, 45.12, -4.31);
            context.lineTo(54.17, 18.49);
            context.bezierCurveTo(56.05, 23.23, 53.73, 28.71, 49, 30.72);
            context.lineTo(15.38, 44.93);
            context.bezierCurveTo(14.04, 45.5, 12.56, 45.78, 10.99, 45.78);
            context.lineTo(10.99, 45.78);
            context.closePath();
            context.fillStyle = fillColor;
            context.fill();


            //// Bezier 3 Drawing
            context.beginPath();
            context.moveTo(-33.61, -41.11);
            context.bezierCurveTo(-32.39, -41.11, -31.17, -40.65, -30.25, -39.74);
            context.lineTo(-29.42, -38.92);
            context.bezierCurveTo(-28.07, -37.58, -26.66, -36.78, -25.78, -36.78);
            context.bezierCurveTo(-25.47, -36.78, -25.22, -36.89, -25.08, -37.11);
            context.bezierCurveTo(-24.93, -37.33, -24.69, -37.44, -24.37, -37.44);
            context.bezierCurveTo(-23.5, -37.44, -22.09, -36.64, -20.73, -35.3);
            context.lineTo(14.18, -0.74);
            context.bezierCurveTo(15.41, 0.48, 17.38, 1.17, 19.25, 1.17);
            context.bezierCurveTo(20.17, 1.17, 21.08, 1, 21.86, 0.65);
            context.lineTo(34.66, -5.05);
            context.bezierCurveTo(35.28, -5.32, 35.92, -5.45, 36.54, -5.45);
            context.bezierCurveTo(38.33, -5.45, 40.02, -4.38, 40.73, -2.6);
            context.lineTo(49.77, 20.2);
            context.bezierCurveTo(50.73, 22.6, 49.54, 25.4, 47.14, 26.42);
            context.lineTo(13.52, 40.63);
            context.bezierCurveTo(12.76, 40.95, 11.89, 41.11, 10.99, 41.11);
            context.bezierCurveTo(9.07, 41.11, 7.06, 40.4, 5.8, 39.15);
            context.lineTo(-40.94, -7.11);
            context.bezierCurveTo(-42.78, -8.94, -43.66, -11.3, -42.88, -12.36);
            context.bezierCurveTo(-42.11, -13.42, -42.99, -15.79, -44.83, -17.62);
            context.lineTo(-48.71, -21.46);
            context.bezierCurveTo(-50.56, -23.29, -50.56, -26.28, -48.71, -28.1);
            context.lineTo(-36.96, -39.74);
            context.bezierCurveTo(-36.04, -40.65, -34.82, -41.11, -33.61, -41.11);
            context.closePath();
            context.moveTo(-33.61, -50.46);
            context.bezierCurveTo(-37.4, -50.46, -40.96, -49, -43.64, -46.35);
            context.lineTo(-55.39, -34.72);
            context.bezierCurveTo(-58.07, -32.07, -59.54, -28.54, -59.54, -24.78);
            context.bezierCurveTo(-59.55, -21.02, -58.07, -17.5, -55.39, -14.85);
            context.lineTo(-52.59, -12.07);
            context.bezierCurveTo(-52.81, -8.17, -51.09, -3.94, -47.62, -0.5);
            context.lineTo(-0.88, 45.77);
            context.bezierCurveTo(2.13, 48.75, 6.46, 50.46, 10.99, 50.46);
            context.bezierCurveTo(13.21, 50.46, 15.31, 50.05, 17.23, 49.23);
            context.lineTo(50.85, 35.02);
            context.bezierCurveTo(54.29, 33.57, 56.98, 30.87, 58.43, 27.44);
            context.bezierCurveTo(59.88, 24, 59.93, 20.22, 58.57, 16.77);
            context.lineTo(49.52, -6.02);
            context.bezierCurveTo(48.47, -8.65, 46.68, -10.88, 44.32, -12.45);
            context.bezierCurveTo(42.01, -13.99, 39.32, -14.8, 36.54, -14.8);
            context.bezierCurveTo(34.55, -14.8, 32.61, -14.39, 30.78, -13.57);
            context.lineTo(19.6, -8.6);
            context.lineTo(-14.05, -41.91);
            context.bezierCurveTo(-16.24, -44.08, -19.73, -46.65, -24.03, -46.78);
            context.bezierCurveTo(-26.65, -49.16, -30.02, -50.46, -33.61, -50.46);
            context.lineTo(-33.61, -50.46);
            context.closePath();
            context.fillStyle = fillColor2;
            context.fill();



            context.restore();
        }

        context.save();
        context.globalAlpha = alpha;
        group2CanvasLayer(canvas.width, canvas.height);
        context.restore();

        context.restore();
    }

    //// Infrastructure

    function clearCanvas(canvas) {
        canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;            
        if(canvas){
            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
        }
    }

    // Possible arguments for 'resizing' parameter are:
    //   'aspectfit': The content is proportionally resized to fit into the target rectangle.
    //   'aspectfill': The content is proportionally resized to completely fill the target rectangle.
    //   'stretch': The content is stretched to match the entire target rectangle.
    //   'center': The content is centered in the target rectangle, but it is NOT resized.
    function applyResizingBehavior(resizing, rect, targetRect) {
    	if (targetRect === undefined || equalRects(rect, targetRect) || equalRects(targetRect, makeRect(0, 0, 0, 0))) {
    		return rect;
    	}

    	var scales = makeSize(0, 0);
    	scales.w = Math.abs(targetRect.w / rect.w);
    	scales.h = Math.abs(targetRect.h / rect.h);
    	switch (resizing) {
    		case 'aspectfit': {
    			scales.w = Math.min(scales.w, scales.h);
    			scales.h = scales.w;
    			break;
    		}
    		case 'aspectfill': {
    			scales.w = Math.max(scales.w, scales.h);
    			scales.h = scales.w;
    			break;
    		}
    		case 'stretch':
    		case undefined:
    		break;
    		case 'center': {
    			scales.w = 1;
    			scales.h = 1;
    			break;
    		}
    		default:
    		throw 'Unknown resizing behavior "' + resizing + '". Use "aspectfit", "aspectfill", "stretch" or "center" as resizing behavior.';
    	}

    	var result = makeRect(Math.min(rect.x, rect.x + rect.w), Math.min(rect.y, rect.y + rect.h), Math.abs(rect.w), Math.abs(rect.h));
    	result.w *= scales.w;
    	result.h *= scales.h;
    	result.x = targetRect.x + (targetRect.w - result.w) / 2;
    	result.y = targetRect.y + (targetRect.h - result.h) / 2;
    	return result;
    }

    function roundedRect(context, x, y, w, h, r) {
    	context.beginPath();
    	context.arc(x+r, y+r, r, Math.PI, 1.5*Math.PI);
    	context.arc(x+w-r, y+r, r, 1.5*Math.PI, 2*Math.PI);
    	context.arc(x+w-r, y+h-r, r, 0, 0.5*Math.PI);
    	context.arc(x+r, y+h-r, r, 0.5*Math.PI, Math.PI);
    	context.closePath();
    }

    function makeRect(x, y, w, h) {
    	return { x: x, y: y, w: w, h: h };
    }

    function equalRects(r1, r2) {
    	return r1.x === r2.x && r1.y === r2.y && r1.w == r2.w && r1.h === r2.h;
    }

    function makeSize(w, h) {
    	return { w: w, h: h };
    }

    //// Public Interface

    // Drawing Methods
    StyleKitName.drawLogo = drawLogo;

    // Utilities
    StyleKitName.clearCanvas = clearCanvas;
    StyleKitName.makeRect = makeRect;
})();

export default {
    // TODO: clear this on route change to prevent invisible update error!
    props: ['primaryColor', 'secondaryColor'],
    mounted(){
      if(this.primaryColor && this.secondaryColor){
        inputPrimaryColor = this.primaryColor;
        inputSecondaryColor = this.secondaryColor;
    }
    var values = { x: 0 };
    var tween = new tweenlib.Tween(values)
    .to({ x: 0.5 }, 1500)
    .easing(tweenlib.Easing.Bounce.Out)
    .onUpdate(function() {
       StyleKitName.clearCanvas('animatedLogoCanvas');
       StyleKitName.drawLogo('animatedLogoCanvas', this.x, StyleKitName.makeRect(115, 115, 240, 240), 'center');
   })
    .start();

    requestAnimationFrame(animate);

    function animate(time) {
       requestAnimationFrame(animate);
       tweenlib.update(time);
   }
}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AnimatedLogo.vue?4d801e82